import { Select, useSelect } from '@pankod/refine-antd'
import { useOne } from '@pankod/refine-core'
import React from 'react'

import {
  TDistrictData,
  TFilterOptions,
} from '@components/DataTableParticipants/types'

// put this inside form.item
export const SelectBidangStudyOptions = ({
  visible = true,
  ...props
}: {
  visible?: boolean
  className?: string
  onChange?: (value: any) => void
  placeholder?: string
  allowClear?: boolean
}) => {
  // staging / lms_ppg_study_field.json
  const { selectProps } = useSelect({
    resource: 'kv?key=lms_ppg_study_field',
    dataProviderName: 'microlearning',
    optionLabel: 'label',
    optionValue: 'value',
    queryOptions: {
      enabled: !!visible,
    },
    defaultValueQueryOptions: {
      enabled: false,
    },
  })

  return (
    <Select
      {...props}
      {...selectProps}
      onSearch={() => {}}
      filterOption={(input, option) =>
        (option!.label as unknown as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  )
}

export const SelectSchoolOptions = (formInjectedProps: any) => {
  const { lptkId } = formInjectedProps

  const { data: schoolData } = useOne({
    resource: `lptk/${lptkId}`,
    id: `school?pageSize=-1`,
    dataProviderName: 'lms',
    queryOptions: {
      enabled: !!formInjectedProps.visible,
    },
  })

  const schoolOptions = schoolData?.data?.data.map((school: any) => ({
    label: school.name,
    value: school.id,
  }))

  return (
    <Select
      {...formInjectedProps}
      options={schoolOptions}
      onSearch={() => {}}
      filterOption={(input, option) =>
        (option!.label as unknown as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  )
}

export const SelectProvinceOptions = (props: any) => {
  const { visible, ...formInjectedProps } = props
  const { data: filterOptions } = useOne<TFilterOptions>({
    resource: `programs/participants`,
    id: `filter-options`,
    dataProviderName: 'lms',
    queryOptions: {
      enabled: !!visible,
    },
  })

  const regionData = filterOptions?.data?.regions

  const provinceOptions = regionData?.map((province) => ({
    label: province.name,
    value: province.kode,
  }))

  provinceOptions?.sort((a, b) => a.label.localeCompare(b.label))

  return (
    <>
      <Select
        {...formInjectedProps}
        options={provinceOptions}
        onSearch={() => {}}
        filterOption={(input, option) =>
          (option!.label as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      />
    </>
  )
}

export const SelectJenjangOptions = (formInjectedProps: any) => {
  const { data: filterOptions } = useOne<TFilterOptions>({
    resource: `programs/participants`,
    id: `filter-options`,
    dataProviderName: 'lms',
    queryOptions: {
      enabled: !!formInjectedProps.visible,
    },
  })

  const jenjangData = filterOptions?.data?.jenjang

  const provinceOptions = jenjangData?.map((jenjang) => ({
    label: jenjang,
    value: jenjang,
  }))

  return (
    <>
      <Select
        {...formInjectedProps}
        options={provinceOptions}
        onSearch={() => {}}
        filterOption={(input, option) =>
          (option!.label as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      />
    </>
  )
}

export const SelectCityOptions = (props: any) => {
  const { provinceId, initialValue, visible, ...formInjectedProps } = props

  const { data: filterOptions } = useOne<TFilterOptions>({
    resource: `programs/participants`,
    id: `filter-options`,
    dataProviderName: 'lms',
    queryOptions: {
      enabled: !!visible,
    },
  })

  const regionData = filterOptions?.data?.regions

  const getCityOptions = (provinceId: string) => {
    const provinceData = regionData?.find(
      (province) => province.kode === provinceId,
    )
    const cityOptions = provinceData?.kabupaten?.map((city) => ({
      label: city.name,
      value: city.kode,
    }))
    cityOptions?.sort((a, b) => a.label.localeCompare(b.label))
    return cityOptions
  }
  return (
    <Select
      {...formInjectedProps}
      options={getCityOptions(provinceId)}
      defaultValue={
        initialValue?.city
          ? [
              {
                label: initialValue && initialValue.city.name,
                value: initialValue && initialValue.city.id,
              },
            ]
          : undefined
      }
      onSearch={() => {}}
      filterOption={(input, option) =>
        (option!.label as unknown as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  )
}

export const SelectDistrictOptions = (props: any) => {
  const { kotaKabId, initialValue, ...formInjectedProps } = props

  const { data: districtOptions, isFetching } = useOne<TDistrictData>({
    resource: `programs/participants/filter-options`,
    id: `kecamatan?kodeKabupaten=${kotaKabId}`,
    dataProviderName: 'lms',
    queryOptions: {
      enabled: !!kotaKabId,
    },
  })
  districtOptions?.data?.kecamatan?.sort?.((a, b) =>
    a.name.localeCompare(b.name),
  )

  return (
    <Select
      {...formInjectedProps}
      loading={isFetching}
      defaultValue={
        initialValue?.district
          ? [
              {
                label: initialValue && initialValue.district.name,
                value: initialValue && initialValue.district.id,
              },
            ]
          : undefined
      }
      options={districtOptions?.data?.kecamatan?.map(({ kode, name }) => ({
        label: name,
        value: kode,
      }))}
      filterOption={(input, option) =>
        ((option?.label ?? '') as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  )
}
